<template>
  <div class="col-12 nopads">
      <!-- Header of collapsable item -->
      <div class="col-12 d-flex justify-content-between align-items-center pb-1">
          <div class="flex-grow-1">
              <h4 class="form-header pointer hover-header" @click.stop="workAssignmentsVisible = !workAssignmentsVisible">
                  {{ $t('menu.work_assignment') }} ({{results.length}})
              </h4>
          </div>
          <div
              v-if="loading"
              id="loader"
              class="spinner-section"
          />
          <div v-else class="ms-2 px-2" @click.stop="workAssignmentsVisible = !workAssignmentsVisible">
              <font-awesome-icon icon="arrow-down" class="pointer no-focus arrow-icon dont-print hover-header" :class="{ rotated:workAssignmentsVisible }"/>
          </div>
      </div>
      <!-- Collapsable content -->
      <div class="routa-collapse" :class="{ collapsed: workAssignmentsVisible }">
          <!-- Summary -->
          <work-assignment-summary class="my-2" :results="results"/>

          <Transition name="fade">
            <work-assignment-list :results="results" class="my-2" @edit="editDetails"/>
          </Transition>

          <base-modal
            v-if="workAssignment !== null"
            size="lg"
            :hide-header="true"
            :hide-footer="true"
            @close="workAssignment = null"
          >
            <work-assignment-editor
              v-if="workAssignment"
              :no-margin="true"
              :area-defect="workAssignment.areaDefect"
              :vehicle-defect="workAssignment.vehicleDefect"
              :observation="workAssignment.observation"
              :work-permission="workAssignment.workPermission"
              :is-observer="isObserver"
              :work-assignment="workAssignment"
              @close="closeEditDetails"
              @close-and-update="closeAndUpdateEditDetails"
            />
          </base-modal>
    </div>
    <hr class="report-divider nopads">
  </div>
</template>

<script>
import {timeUtils} from "@/components/mixins/TimeUtils";
import {restApi} from "@/components/mixins/RestApiMixin";
import WorkAssignmentList from "@/components/workassignment/WorkAssignmentList";
import WorkAssignmentEditor from "@/components/workassignment/WorkAssignmentEditor";
import {workAssignmentHelper} from "../mixins/WorkAssignmentMixin";
import WorkAssignmentSummary from "@/components/contractreport/WorkAssignmentSummaryValues.vue";
import BaseModal from "@/components/BaseModal";

export default {
    name: "ContractReportWorkAssignments",
    components: {BaseModal, WorkAssignmentSummary, WorkAssignmentList, WorkAssignmentEditor },
    mixins: [timeUtils, restApi, workAssignmentHelper],
    props: {
        searchParams: {
            type: Object,
            default() {
                return null
            }
        },
        isObserver: Boolean
    },
    data: function () {
        return {
            loading: false,
            results: [],
            workAssignmentsVisible: false,
            workAssignment: null
        }
    },
    watch: {
        searchParams: function () {
            this.fetchMaterialReports()
        }
    },
    created() {
        this.fetchMaterialReports()
    },
    methods: {
        fetchMaterialReports: function () {
            if (this.searchParams) {
                let mappedParams = {
                    contract: this.searchParams.contract,
                    created_from: this.searchParams.dateFrom ? this.getDateIsoString(new Date(this.searchParams.dateFrom)) : null,
                    created_to: this.searchParams.dateTo ? this.getDateIsoString(new Date(this.searchParams.dateTo)) : null
                }
                this.$emit('loading', true)
                this.loading = true
                this.restFetchParams(this.workAssignmentUrl, mappedParams, this.handleResponse)
            }
        },
        editDetails: function (id) {
            this.workAssignment = this.results.find(item => item.id === id)
        },
        closeEditDetails: function () {
            this.workAssignment = null
        },
        closeAndUpdateEditDetails: function () {
            this.fetchMaterialReports()
            this.workAssignment = null
        },
        handleResponse: function (response) {
            if (response) {
                this.results = response.data
            }
            this.loading = false
            this.$emit('loading', false)
        },
    }
}
</script>

